import BankSymbol from './bank-symbol';

export default BankSymbol;
